import React from 'react';
import {
  TRUSTED_CLIENTS,
  TRUSTED_CLIENTS_SCROLL_THRESHOLD,
} from '../../config/trustedClients';

function clientClassName(client) {
  return [
    'eb-client-banner__name',
    client.font === 'script' ? 'eb-client-banner__name--script' : '',
  ]
    .filter(Boolean)
    .join(' ');
}

const NameGroup = ({ clients, decorative = false }) => (
  <div className="eb-client-banner__group" aria-hidden={decorative || undefined}>
    {clients.map((client, i) => (
      <span
        key={`${decorative ? 'dup-' : ''}${client.name}-${i}`}
        className={clientClassName(client)}
      >
        {client.name}
      </span>
    ))}
  </div>
);

const EventBrellaClientMarquee = () => {
  const clients = TRUSTED_CLIENTS;
  const shouldScroll = clients.length > TRUSTED_CLIENTS_SCROLL_THRESHOLD;

  return (
    <section className="eb-client-banner" aria-label="Trusted by">
      <div className="eb-client-banner__inner">
        <p className="eb-client-banner__label">Trusted by</p>
        {shouldScroll ? (
          <div className="eb-client-banner__viewport">
            <div className="eb-client-banner__scroll">
              <NameGroup clients={clients} />
              <NameGroup clients={clients} decorative />
            </div>
          </div>
        ) : (
          <ul className="eb-client-banner__names">
            {clients.map((client) => (
              <li key={client.name} className={clientClassName(client)}>
                {client.name}
              </li>
            ))}
          </ul>
        )}
      </div>
    </section>
  );
};

export default EventBrellaClientMarquee;
